package app.nestbridge.feature.invitations.presentation

import com.karawek.core.auth.presenter.BaseOtpVerificationPresenter
import com.karawek.core.auth.screen.OtpVerificationResult
import app.nestbridge.feature.invitations.screen.InvitationOtpVerificationScreen
import app.nestbridge.feature.invitations.usecase.AcceptInvitationWithVerificationUseCase
import app.nestbridge.feature.invitations.usecase.InitiateInvitationVerificationUseCase
import com.slack.circuit.codegen.annotations.CircuitInject
import com.slack.circuit.runtime.Navigator
import me.tatarka.inject.annotations.Assisted
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope

@CircuitInject(
    screen = InvitationOtpVerificationScreen::class,
    scope = AppScope::class,
)
@Inject
class InvitationOtpVerificationPresenter(
    @Assisted private val screen: InvitationOtpVerificationScreen,
    @Assisted navigator: Navigator,
    private val initiateInvitationVerification: InitiateInvitationVerificationUseCase,
    private val acceptInvitationWithVerification: AcceptInvitationWithVerificationUseCase,
) : BaseOtpVerificationPresenter(
    channel = screen.channel,
    destination = screen.destination,
    navigator = navigator,
) {

    override suspend fun onSendOtp(): Result<Unit> =
        initiateInvitationVerification(screen.invitationId)

    override suspend fun onVerifyOtp(otpCode: String): Result<OtpVerificationResult> =
        acceptInvitationWithVerification(
            invitationId = screen.invitationId,
            verificationCode = otpCode,
        ).map {
            OtpVerificationResult(status = OtpVerificationResult.Status.Verified)
        }
}
